import OrderFoodListItem from '@components/order/components/common/order-food/OrderFoodListItem';
import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import { Box, List } from '@mui/material';
import _ from 'lodash';
import React from 'react';

interface FoodListProps {
    orderListViewStore: OrderListViewStore;
}

const FoodList: React.FC<FoodListProps> = ({ orderListViewStore }) => {
    const { orderRepeatContainer } = orderListViewStore;

    if (orderRepeatContainer === undefined) {
        return null;
    }


    const { orderOriginal } = orderRepeatContainer;

    return (
        <Box display={"flex"} flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            {_.map(orderOriginal.orderFoods, (orderFood) => (
                <OrderFoodListItem key={orderFood.foodId} orderFood={orderFood} />
            ))}
        </Box>
    )
}

export default FoodList;